import React from 'react';
import styled from 'styled-components';
import NumberField from '@cld/number-field';
import { globalTheme } from '@cld/component-theme';

import { InputWrapper } from './InputWrapper';
import { CurrentColorUnit } from './CurrentColorUnit';

const ColorBox = styled(NumberField).attrs({ numericDecorator: false, size: 'xs' })`
  margin-right: ${globalTheme.spacing.xxs};
  border: solid 1px ${globalTheme.palette.secondaryAlt};
  background-color: ${globalTheme.palette.surfaceAlt};
`;

/**
 * Minimal segment color box displaying number field and unit label
 * @param value
 * @param min
 * @param max
 * @param step
 * @param view
 * @param onChange
 * @param onBlur
 * @param name
 * @returns {JSX.Element}
 * @constructor
 */
export const SegmentField = ({ value, min, max, step, onBlur, onChange, name }) => {
  return (
    <InputWrapper>
      <ColorBox onChange={onChange} min={min} max={max} step={step} value={value} onBlur={onBlur} name={name} />
      <CurrentColorUnit>{name}</CurrentColorUnit>
    </InputWrapper>
  );
};
